import { Layout } from 'antd';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';
import { ErrorFallback } from '../components/error-fallback';
import { AppHeader } from './app-header';

const { Content } = Layout;

export const MainLayout = () => {
  return (
    <Layout className='min-h-screen'>
      <AppHeader />
      <Content className='p-6 bg-gray-50'>
        <ErrorBoundary fallbackRender={({ error }) => <ErrorFallback error={error} />}>
          <Outlet />
        </ErrorBoundary>
      </Content>
    </Layout>
  );
};
